import {
  camelCaseStringToNormalText,
  generateOptions,
} from "@/services/generic.methods";
import { createSlice } from "@reduxjs/toolkit";

/**
 * @name @createSlice
 * @description create redux store slice for Workflow RightPanel
 **/
export const WFRightPanelSlice = createSlice({
  name: "WFRightPanel",
  initialState: {
    loading: false,
    openSMSEditModal: false,
    WFWaitTypes: null,
  },

  reducers: {
    setLoadingToState: (state, action) => {
      state.loading = action.payload;
    },
    setOpenSMSEditModalToState: (state, action) => {
      state.openSMSEditModal = action.payload;
    },
    setWFWaitTypesToState: (state, action) => {
      state.WFWaitTypes = action.payload;
    },
  },
});

export const {
  setLoadingToState,
  setSMSTemplateToState,
  setOpenSMSEditModalToState,
  setWFWaitTypesToState,
} = WFRightPanelSlice.actions;

/* called a selector and allows to select values from the state */
export const getLoading = (state) => {
  return state.WFRightPanel?.loading;
};

export const getRightPanelState = (state) => {
  return state.WFRightPanel;
};

export const getWFWaitTypesState = (state) => {
  return state.WFRightPanel.WFWaitTypes;
};

export const getWFWaitTypesAsync = (query) => (dispatch) => {
  return query()
    .then(async (res) => {
      let { data } = res;
      if (data?.wfWaitTypes && data?.wfWaitTypes?.items) {
        let tempData = data?.wfWaitTypes?.items.map((item) => ({
          ...item,
          name:
            item.name !== "SMS"
              ? camelCaseStringToNormalText(item.name)
              : item?.name,
        }));
        let waitTypes = generateOptions(tempData, "name", "id");
        dispatch(setWFWaitTypesToState(waitTypes));

        return Promise.resolve(waitTypes);
      }
      return Promise.reject(res);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default WFRightPanelSlice.reducer;
